export function getMarketingPageTitle(pathname: string): string {
  if (pathname === '/marketing/dashboard') return 'Dashboard';
  if (pathname === '/marketing/emails') return 'Marketing emails';
  if (pathname === '/marketing/whatsapp') return 'WhatsApp marketing';
  return 'Marketing';
}
